<template>
  <div
    class="session-cancellation"
    data-ui="cancellation-policy"
  >
    <h3
      class="session-cancellation__title"
      data-ui="cancellation-policy-title"
    >
      Cancellation policy
    </h3>
    <!-- TODO: remove when policy changes, hopefully when new PDP is built -->
    <CdrText
      v-if="showNewCancellationPolicy"
      tag="p"
      data-ui="cancellation-policy-link-new"
    >
      You may cancel your paid registration up to 7 days before your scheduled event for a full
      refund. View our
      <CdrLink
        href="/events/resources/cancellation"
        rel="nofollow"
        target="_blank"
        @click="handleMetrics"
      >
        Cancellation Policy
      </CdrLink>
      <span>{{ '.' }}</span>
    </CdrText>
    <CdrLink
      v-else
      href="/events/resources/cancellation"
      class="session-cancellation__link"
      rel="nofollow"
      target="_blank"
      data-ui="cancellation-policy-link-old"
      @click="handleMetrics"
    >
      Outdoor School Cancellation Policy
    </CdrLink>
  </div>
</template>

<script>
import { CdrLink, CdrText } from '@rei/cedar';
import isAfter from 'date-fns/is_after';
import metrics from '../mixins/metrics';

export default {
  name: 'SessionCancellationPolicyComponent',
  components: {
    CdrLink,
    CdrText,
  },
  mixins: [metrics],
  props: {
    /**
     * The session start date
     */
    // TODO: remove when policy changes, hopefully when new PDP is built
    startDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    /**
     * Determine whether we should show the new cancellation policy
     * @returns a boolean
     */
    // TODO: remove when policy changes, hopefully when new PDP is built
    showNewCancellationPolicy() {
      return isAfter(this.startDate, '12/31/2022');
    },
  },
  methods: {
    handleMetrics() {
      const linkName = '{{ pageName }}_forms_Outdoor School Cancellation Policy';
      this.metricsClick({ linkName });
    },
  },
};
</script>
